import React from "react";

import styles from "./Input.module.scss";
import { BlockTooltip } from "../../components/BlockTooltip/BlockTooltip";
import { TooltipProvider } from "../../context/TooltipContext";
import { AlertIcon } from "../../assets/icons/AlertIcon";

export default function Input({
  label,
  className,
  onClickRightIcon,
  labelStyle,
  rightIcon,
  backgroundStyle,
  inputStyle,
  bottomString,
  refFocus,
  hint,
  classNameTooltip,
  rightIconStyle,
  wrapperStyle,
  errorMessage,
  readOnly,
  isFromAuth = false,
  ...rest
}) {
  return (
    <div className={`${styles.wrapper} ${wrapperStyle}`}>
      <div className={`${styles.container} ${className}`}>
        <div className={`${styles.background} ${backgroundStyle}`}>
          <label className={` ${labelStyle} ${styles.label}`}>{label}</label>
          <TooltipProvider>
            {hint && (
              <BlockTooltip
                className={classNameTooltip}
                tooltipId={hint.id}
                stepsData={hint.stepsData}
              />
            )}
          </TooltipProvider>
        </div>

        <div
          className={`${styles.input} ${inputStyle} ${
            readOnly ? styles.readOnly : ""
          }`}
        >
          <input
            {...rest}
            ref={refFocus}
            readOnly={readOnly}
            step={rest.type === "time" ? 1 : undefined}
          />
          <div
            className={`${styles.rightIcon} ${rightIconStyle}`}
            onClick={onClickRightIcon}
          >
            {rightIcon}
          </div>
        </div>
      </div>

      {isFromAuth ? (
        <div
          className={`${styles.errorMessageContainer}`}
          style={{ height: 17 }}
        >
          {errorMessage && (
            <>
              <AlertIcon />
              <p className={`${styles.errorMessage}`}>{errorMessage}</p>
            </>
          )}{" "}
        </div>
      ) : (
        errorMessage && (
          <div className={`${styles.errorMessageContainer}`}>
            <AlertIcon />
            <p className={`${styles.errorMessage}`}>{errorMessage}</p>
          </div>
        )
      )}

      {bottomString && (
        <p className={`${styles.bottomString}`}>{bottomString}</p>
      )}
    </div>
  );
}
